import { ArrowRight, Phone } from '@phosphor-icons/react';
import './Hero.css';

const SECTORS = ['Maritiem', 'Bouw', 'Metaal', 'Industrie', 'Brandwacht'];

export default function Hero() {
  // Scroll to the contact form; optionally flip it to the "Ik zoek werk" tab.
  const goToContact = (asWorker) => (e) => {
    e.preventDefault();
    if (asWorker) window.dispatchEvent(new CustomEvent('ozel:apply', { detail: {} }));
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="hero" id="home">
      <div className="hero-media" aria-hidden="true">
        <img src="/assets/hero-werf.jpg" alt="" className="hero-photo" fetchPriority="high" />
        <span className="hero-scrim" />
      </div>

      <div className="hero-inner">
        <p className="hero-eyebrow">Technisch uitzendbureau — Rotterdam</p>

        <h1 className="hero-title">
          Vakmensen voor de haven,<br />
          bouw en industrie
        </h1>

        <p className="hero-lead">
          Gecertificeerde lassers, ijzerwerkers, brandwachten en scheepstimmerlieden —
          inzetbaar op scheepswerven en industriële projecten in Rotterdam en omstreken.
        </p>

        <div className="hero-actions">
          <a href="#contact" className="hero-btn hero-btn--primary" onClick={goToContact(false)}>
            Personeel aanvragen <ArrowRight size={17} weight="bold" aria-hidden="true" />
          </a>
          <a href="#contact" className="hero-btn hero-btn--ghost" onClick={goToContact(true)}>
            Ik zoek werk
          </a>
          <a href="tel:+31104159100" className="hero-tel">
            <Phone size={15} weight="regular" aria-hidden="true" /> 010 415 9100
          </a>
        </div>

        {/* A technical spec strip — widths follow the content, not three equal columns. */}
        <dl className="hero-specs">
          <div>
            <dt>Sectoren</dt>
            <dd>{SECTORS.join(', ')}</dd>
          </div>
          <div>
            <dt>Certificering</dt>
            <dd>VCA, lascertificaten CO2 &amp; Electric</dd>
          </div>
          <div>
            <dt>Werkgebied</dt>
            <dd>Rotterdamse haven e.o.</dd>
          </div>
        </dl>
      </div>

    </section>
  );
}
